import { isShopifyInstallPage } from '@/flows/shopifyInstall';
import { getOnboardingNavigationBehavior } from '@/routeBehavior';
import { readReferralCode } from '@common/referral/referralAttribution';

interface ShouldDelayOnboardingRedirectParams {
    profileHasWorkspace: boolean;
    currentWorkspaceId?: string | null;
    isLoadingWorkspaces: boolean;
    pendingPasswordSetup?: boolean;
    pendingWorkspaceReturn?: boolean;
    currentPathname?: string;
    search?: string;
}

export const shouldDelayOnboardingRedirect = ({
    profileHasWorkspace,
    currentWorkspaceId,
    isLoadingWorkspaces,
    pendingPasswordSetup,
    pendingWorkspaceReturn,
    currentPathname = '',
    search = '',
}: ShouldDelayOnboardingRedirectParams): boolean => {
    if (isShopifyInstallPage(currentPathname)) return true;

    if (profileHasWorkspace) {
        return false;
    }

    if (pendingPasswordSetup) {
        return true;
    }

    if (pendingWorkspaceReturn) {
        return true;
    }

    if (
        getOnboardingNavigationBehavior(currentPathname).owner === 'auth-page'
        && readReferralCode(search)
    ) {
        return true;
    }

    return isLoadingWorkspaces || Boolean(currentWorkspaceId);
};
